import axios from "axios";
import config from "./config";
const API_BASE = process.env.REACT_APP_BACKEND_API + "/api/merchant";

export const getMerchants = async () => {
  try {
    const response = await axios.get(`${API_BASE}/GetMerchants`, config());
    return {
      status: response.status,
      payload: response.data,
    };
  } catch (error) {
    return {
      status: error?.response?.status || 500,
      payload: null,
    };
  }
};
